import React, { useEffect, useRef, useState } from "react";
import styles from "./chapter4.module.css";
import { Link } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import MembershipModal from "../../../components/Modal/MembershipModal";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter4.json";


export default function Chapter_4() {
  const router = useRouter();
  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])


  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
      <Head>
        <title>Introduction of our school | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-IV"
        ></meta>
        <meta
          property="og:title"
          content="Introduction of our school | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter4_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration of a serene, sacred space with an ancient, ornate structure, symbolizing the spiritual school of Our Divine Infinite Being. The setting is surrounded by natural elements and soft light, representing wisdom, learning, and the nurturing of spiritual growth."
        ></meta>
        <meta
          property="og:description"
          content="Our inner Mystery School consists of learning ritual Theurgy, meditation and spiritual advancement through the invocation of, and participation with, arcane forces of nature and Cosmic Astrological archetypes."
        ></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=4"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter4_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration of a serene, sacred space with an ancient, ornate structure, symbolizing the spiritual school of Our Divine Infinite Being. The setting is surrounded by natural elements and soft light, representing wisdom, learning, and the nurturing of spiritual growth."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=4"></meta>
        <meta name="twitter:title" content="Opportunities, structure and plans | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Our inner Mystery School consists of learning ritual Theurgy, meditation and spiritual advancement through the invocation of, and participation with, arcane forces of nature and Cosmic Astrological archetypes."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=4" />
      </Head>


      <Common_html BlockData={BlockData} />


      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen} />
    </>
  );
}
